// src/components/common/CopyWithFeedbackButton.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { Button, Tooltip } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';
import { toast } from 'react-toastify';

const CopyWithFeedbackButton = ({
  textToCopy,
  children,
  ...buttonProps
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success('Copied!');
      setCopied(true);
    } catch (err) {
      console.error(err);
      toast.error('Failed to copy.');
    }
  }, [textToCopy]);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(t);
  }, [copied]);

  return (
    <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
      <Button
        {...buttonProps}
        onClick={handleCopy}
        color={copied ? 'success' : buttonProps.color || 'primary'}
        startIcon={copied ? <Check /> : <ContentCopy />}
      >
        {children}
      </Button>
    </Tooltip>
  );
};

export default CopyWithFeedbackButton;
